/*
 * mod='label'
 * author: v_xmdjliu
 * time: 2020-09-25
 */

import { smb_fetch, getAgpApiUrl } from "../../../fetch"

const getKpiApiUrl = (mod, act) => {
  const result = getAgpApiUrl(mod, act)

  return result
}
/**
 * 获取标签列表
 * @return
 */
export const getLabelList = (data) => {
  const url = getKpiApiUrl("customized_label", "get_label_type_list")
  const params = $.extend(
    true,
    {
      method: "GET",
    },
    data
  )

  return smb_fetch(url, params)
}

/**
 * 获取标签详情
 * @return
 */
export const getLabelDetails = (data) => {
  const url = getKpiApiUrl("customized_label", "get_label_type")
  const params = $.extend(
    true,
    {
      method: "GET",
    },
    data
  )

  return smb_fetch(url, params)
}
/**
 * 修改标签
 * @return
 */
export const updateLabel = (data) => {
  const url = getKpiApiUrl("customized_label", "update_label_type")
  const params = $.extend(
    true,
    {
      method: "POST",
    },
    data
  )

  return smb_fetch(url, params)
}
/**
 * 删除标签
 * @return
 */
export const deleteLabel = (data) => {
  const url = getKpiApiUrl("customized_label", "delete_label_type")
  const params = $.extend(
    true,
    {
      method: "POST",
    },
    data
  )
  return smb_fetch(url, params)
}
/**
 * 新增标签
 * @return
 */
export const addLabel = (data) => {
  const url = getKpiApiUrl("customized_label", "create_label_type")
  const params = $.extend(
    true,
    {
      method: "POST",
    },
    data
  )

  return smb_fetch(url, params)
}

/**
 * 覆盖广告主标签
 * @return
 */
export const batchUpdate = (data) => {
  const url = getKpiApiUrl("customized_label", "batch_update")
  const params = $.extend(
    true,
    {
      method: "POST",
    },
    data
  )

  return smb_fetch(url, params)
}

/**
 * 覆盖更新服务商标签
 * @return
 */
export const updateAgencyLable = (data) => {
  const url = getKpiApiUrl("customized_label", "update_agency_label")
  const params = $.extend(
    true,
    {
      method: "POST",
    },
    data
  )

  return smb_fetch(url, params)
}

export default {
  getLabelList,
  getLabelDetails,
  updateLabel,
  deleteLabel,
  addLabel,
  batchUpdate,
  updateAgencyLable,
}
